export function appendAnswerForSurvey(survey, answer, answersContainer) {
    var radioName = "survey_" + answer.id;
    var inputId = radioName + "_answer_" + answer.csa_id;
    var answerText = "";
    if (parseInt(survey.type) === 1) { // Typ Einfachantwort
        if (answer.csa_image !== "" && answer.csa_image !== undefined && answer.csa_image !== null) {
            answerText =
                "<div class='imageCheckboxen'>" +
                "<label class=\"form-radio-label imageCheckbox\">" +
                "<input type=\"radio\" name=\"" + radioName + "\"  id=\"" + inputId + "\">" +
                "<label for=\"" + inputId + "\">" +
                "<div style=\"background-image:url(/userdata/survey/resize/" + answer.csa_image + ")\"></div>" +
                "</label>" +
                "</label>" +
                "</div>"
            ;
        } else {
            answerText =
                "<div>" +
                "<label class=\"form-radio-label specialradiobox\">" +
                "<input type=\"radio\" name=\"" + radioName + "\"  id=\"" + inputId + "\">" +
                answer.csa_description +
                "<label for=\"" + inputId + "\"></label>" +
                "   </label>" +
                "</div>"
            ;
        }
    } else { // Mehrfachantwort
        if (answer.csa_image !== "" && answer.csa_image !== undefined && answer.csa_image !== null) {
            answerText =
                "<div class='imageCheckboxen'>" +
                "<label class=\"form-radio-label imageCheckbox\">" +
                "<input type=\"checkbox\" name=\"" + inputId + "\"  id=\"" + inputId + "\">" +
                "<label for=\"" + inputId + "\">" +
                "<div style=\"background-image:url(/userdata/survey/resize/" + answer.csa_image + ")\"></div>" +
                "</label>" +
                "</label>" +
                "</div>"
            ;
        } else {
            answerText =
                "<div>" +
                "<label class=\"form-radio-label specialcheckbox\">" +
                "<input name=\"" + inputId + "\"  id=\"" + inputId + "\" type=\"checkbox\">" +
                answer.csa_description +
                "<label for=\"" + inputId + "\"></label>" +
                "</label>" +
                "</div>"
            ;
        }
    }
    answersContainer.append(answerText);
}